export type UiBuildInfo = { version?: string | null; commit?: string | null; environment?: string | null }

/** Bun's development HTML server does not run build.ts's production constant substitution. */
export function loadedUiBuild(): UiBuildInfo {
  return {
    version: typeof __UI_VERSION__ === "undefined" ? "development" : __UI_VERSION__,
    commit: typeof __UI_COMMIT__ === "undefined" ? null : __UI_COMMIT__,
    environment: typeof __UI_ENVIRONMENT__ === "undefined" ? "development" : __UI_ENVIRONMENT__,
  }
}

export function isUiBuildStale(loaded: UiBuildInfo, deployed: UiBuildInfo | null): boolean {
  const known = (value: string | null | undefined) => !!value && value !== "unknown"
  return known(loaded.commit) && known(deployed?.commit) && loaded.commit !== deployed?.commit
}
